var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var splide;
var loadedPacks = 0;

var Pack = function (_React$Component) {
    _inherits(Pack, _React$Component);

    function Pack(props) {
        _classCallCheck(this, Pack);

        var _this = _possibleConstructorReturn(this, (Pack.__proto__ || Object.getPrototypeOf(Pack)).call(this, props));

        _this.state = {
            loaded: false,
            imgSrc: ''
        };

        _this.handleImgLoad = _this.handleImgLoad.bind(_this);
        return _this;
    }

    _createClass(Pack, [{
        key: "handleImgLoad",
        value: function handleImgLoad(event) {
            this.setState({
                loaded: true,
                imgSrc: URL.createObjectURL(event.rawResult)
            });

            loadedPacks += 1;
            if (loadedPacks === 20) setTimeout(function () {
                return splide.refresh();
            }, 300);
        }
    }, {
        key: "loadImage",
        value: function loadImage(data) {
            var queue = new createjs.LoadQueue();
            queue.addEventListener("fileload", this.handleImgLoad);
            queue.loadFile(data.ImageUrl);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.data !== this.props.data) {
                this.loadImage(this.props.data);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(
                "li",
                { "class": "splide__slide" },
                React.createElement(
                    "div",
                    { "class": this.state.loaded ? 'pack-wrapper' : 'pack-wrapper loading' },
                    React.createElement(
                        "a",
                        { href: this.props.data === null ? '' : this.props.data.Url },
                        React.createElement("img", { src: this.state.imgSrc })
                    ),
                    React.createElement(
                        "div",
                        { "class": "label" },
                        React.createElement(
                            "div",
                            { "class": "category-name" },
                            this.props.data === null ? '' : this.props.data.Category
                        ),
                        React.createElement(
                            "div",
                            { "class": "pack-name" },
                            this.props.data === null ? '' : this.props.data.Name
                        )
                    ),
                    React.createElement(
                        "div",
                        { "class": "loading-dots" },
                        React.createElement(
                            "span",
                            null,
                            "..."
                        )
                    )
                )
            );
        }
    }]);

    return Pack;
}(React.Component);

var PackCarrousel = function (_React$Component2) {
    _inherits(PackCarrousel, _React$Component2);

    function PackCarrousel(props) {
        _classCallCheck(this, PackCarrousel);

        var _this2 = _possibleConstructorReturn(this, (PackCarrousel.__proto__ || Object.getPrototypeOf(PackCarrousel)).call(this, props));

        var packs = [];
        for (var i = 0; i < 20; i++) {
            packs.push({ key: i, data: null });
        }

        _this2.state = { packs: packs };
        _this2.updateState = _this2.updateState.bind(_this2);

        return _this2;
    }

    _createClass(PackCarrousel, [{
        key: "mountSplide",
        value: function mountSplide() {
            var options = {
                direction: "ltr",
                autoplay: false,
                interval: 3000,
                speed: 400,
                type: "loop",
                perPage: 10,
                perMove: 1,
                gap: 25,
                pagination: false,
                breakpoints: {
                    1200: {
                        fixedWidth: 89,
                        height: 130,
                        gap: 45,
                        focus: 'center'

                    },
                    768: {
                        fixedWidth: 89,
                        height: 130,
                        gap: 14
                    },
                    576: {
                        fixedWidth: 89,
                        height: 130,
                        gap: 31
                    }
                }

            };
            splide = new Splide("#splide-pack-carrousel", options).mount();
        }
    }, {
        key: "fetchPackData",
        value: function fetchPackData() {
            var _this3 = this;

            fetch('https://blips.fm/BlipsAPI/GetRandomMusicPacks') //atualizar este endereço apenas para producçao
            .then(function (response) {
                return response.json();
            }).then(function (json) {
                return _this3.updateState(json);
            });
        }
    }, {
        key: "updateState",
        value: function updateState(data) {
            var packs = [];
            for (var i = 0; i < 20; i++) {
                packs.push({ key: i, data: data[i] });
            }
            this.setState({ packs: packs });
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.mountSplide();
            this.fetchPackData();
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(
                    "div",
                    { "class": "title" },
                    "Game Music Packs"
                ),
                React.createElement(
                    "section",
                    { id: "splide-pack-carrousel", "class": "splide", "aria-label": "Music Pack Carrousel" },
                    React.createElement(
                        "div",
                        { "class": "splide__track" },
                        React.createElement(
                            "ul",
                            { "class": "splide__list" },
                            this.state.packs.map(function (pack) {
                                return React.createElement(Pack, { key: pack.key, data: pack.data });
                            })
                        )
                    )
                )
            );
        }
    }]);

    return PackCarrousel;
}(React.Component);

var e = React.createElement;
var root = ReactDOM.createRoot(document.querySelector("#pack-carrousel"));
root.render(e(PackCarrousel));